export { default } from './UnsubscribeSingle';
